export default __webpack_public_path__ + "static/media/q3.a4c10792.jpg";